<form class="or-form or-form-schedule" name="form" [formGroup]='scheduleForm' novalidate="novalidate">
  <div class="or-form-body">
    <ol class="or-form-items or-form-schedule-details">
      <div>
        <mat-form-field appearance='fill'>
          <mat-label>Schedule Name</mat-label>
          <input matInput formControlName="name" data-cy="schedule-name-input" />
        </mat-form-field>
      </div>
      <div class="space-x-4 flex flex-row items-center">
        <mat-slide-toggle data-cy="start-solar-events-toggle" color="primary" (change)="onStartSolarEventsToggle()" formControlName="isStartSolarEvent">Start with Solar Events</mat-slide-toggle>
        <mat-form-field appearance='fill' class='schedule-form-date'>
          <mat-label>Start Date</mat-label>
          <input
            matInput
            [min]="minSelectableStartDate"
            [max]="maxSelectableStartDate"
            [placeholder]="'DD/MM/YYYY'"
            formControlName="startDate"
            [matDatepicker]='startDatepicker'
            (dateChange)="onChangeStartDate()">
          <mat-datepicker-toggle matSuffix [for]='startDatepicker'></mat-datepicker-toggle>
          <mat-datepicker #startDatepicker></mat-datepicker>
            @if (startDate?.errors?.required || startDate?.errors?.matDatepickerMin) {
              <mat-error data-cy="start-date-error">
                {{ startDate?.errors?.required ? 'Start date is required' : 'Start date cannot be in the past' }}
              </mat-error>
            }
        </mat-form-field>
        @if(!scheduleForm.value.isStartSolarEvent) {
          <mat-form-field appearance='fill'>
            <mat-label>Start Time</mat-label>
            <mat-select
              data-cy="start-time-dropdown"
              [ngClass]="'mat-select-arrow'"
              formControlName='startTime'
              (selectionChange)="onChangeStartTime()">
              @for (time of timeOptions; track time) {
                <mat-option [disabled]="time.disabled" [value]='time'>{{time.timeString}}</mat-option>
              }
            </mat-select>
            @if (scheduleForm.controls.startTime?.errors?.required) {
              <mat-error data-cy="start-time-error">
                Start time is required
              </mat-error>
            }
          </mat-form-field>
        } @else{
          <mat-form-field appearance='fill'>
            <mat-label>Event</mat-label>
            <mat-select
              data-cy="start-solar-events-dropdown"
              [ngClass]="'mat-select-arrow'"
              formControlName='startSolarEvent'
              (selectionChange)="onChangeStartSolarEvent()">
              @for (event of solarEventOptions; track event) {
                <mat-option [value]='event.value'>{{event.label}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field  appearance='fill'>
            <mat-label>Offset Start Time</mat-label>
            <mat-select data-cy="offset-start-time-dropdown" [ngClass]="'mat-select-arrow'"
                        formControlName='offsetStartTime'
                        (selectionChange)="onChangeOffsetStartTime()">
              <mat-option [value]="atSameTime.time">{{ atSameTime.label }}</mat-option>
              <mat-optgroup label="Before">
                @for(time of offsetBeforeTimes; track $index) {
                  <mat-option [value]="time.time">{{ time.label }}</mat-option>
                }
              </mat-optgroup>
              <mat-optgroup label="After">
                @for(time of offsetAfterTimes; track $index) {
                  <mat-option [value]="time.time">{{ time.label }}</mat-option>
                }
              </mat-optgroup>
            </mat-select>
          </mat-form-field>
        }
      </div>
      <div class="space-x-4 flex flex-row items-center">
        <mat-slide-toggle data-cy="end-solar-events-toggle" color="primary" (change)="onEndSolarEventsToggle()" formControlName="isEndSolarEvent">Ends with Solar Events</mat-slide-toggle>
        <mat-form-field appearance='fill' class='schedule-form-date'>
          <mat-label>End Date</mat-label>
          <input
            matInput
            [placeholder]="'DD/MM/YYYY'"
            formControlName="endDate"
            [min]="minSelectableEndDate"
            [max]="maxSelectableEndDate"
            [matDatepicker]='endDatepicker'
            (dateChange)="onChangeEndDate()">
          <mat-datepicker-toggle matSuffix [for]='endDatepicker'></mat-datepicker-toggle>
          <mat-datepicker #endDatepicker></mat-datepicker>
            @if (endDate?.errors?.required || endDate?.errors?.matDatepickerMin) {
            <mat-error data-cy="end-date-error">
              {{ endDate?.errors?.required ? 'End date is required' : 'End date cannot be in the past' }}
            </mat-error>
            }
        </mat-form-field>
        @if(!scheduleForm.value.isEndSolarEvent) {
          <mat-form-field appearance='fill'>
            <mat-label>End Time</mat-label>
            <mat-select
              data-cy="end-time-dropdown"
              [ngClass]="'mat-select-arrow'"
              formControlName='endTime'
              (selectionChange)="onChangeEndTime()">
              @for (time of timeOptions; track time) {
                <ng-container>
                  <mat-option [disabled]="time.disabled" [value]='time'>{{time.timeString}}</mat-option>
                </ng-container>
              }
            </mat-select>
            @if (scheduleForm.controls.endTime?.errors?.required) {
              <mat-error data-cy="end-time-error">
                End time is required
              </mat-error>
            }
          </mat-form-field>
        } @else {
          <mat-form-field appearance='fill'>
            <mat-label>Event</mat-label>
            <mat-select
              data-cy="end-solar-events-dropdown"
              [ngClass]="'mat-select-arrow'"
              formControlName='endSolarEvent'
              (selectionChange)="onChangeEndSolarEvent()">
              @for (event of solarEventOptions; track event) {
                <mat-option [value]='event.value'>{{event.label}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field  appearance='fill'>
            <mat-label>Offset End Time</mat-label>
            <mat-select data-cy="offset-end-time-dropdown" [ngClass]="'mat-select-arrow'"
                        formControlName='offsetEndTime'
                        (selectionChange)="onChangeOffsetEndTime()">
              <mat-option [value]="atSameTime.time">{{ atSameTime.label }}</mat-option>
              <mat-optgroup label="Before">
                @for(time of offsetBeforeTimes; track $index) {
                  <mat-option [value]="time.time">{{ time.label }}</mat-option>
                }
              </mat-optgroup>
              <mat-optgroup label="After">
                @for(time of offsetAfterTimes; track $index) {
                  <mat-option [value]="time.time">{{ time.label }}</mat-option>
                }
              </mat-optgroup>
            </mat-select>
          </mat-form-field>
        }
      </div>
    </ol>
  </div>
  <div class="pt-4 pb-4 or-form-title"><h2>Rules</h2></div>
  @if(schedule.rules?.length == 0) {
    <app-notification-block
      [header]="'No rules for schedule!'"
      [statusClass]="StatusClass.ERROR"
      [showButton]="true"
      (buttonAction)="addRule()"
      [buttonText]="'Add Rule'">
      This schedule doesn't have any rules yet. Please add at least one rule before saving.
    </app-notification-block>
  } @else  {
    <div class="pb-2">
      @for(rule of schedule.rules; track $index) {
        <div class="or-form-schedule-ruleset-rule" >
          <app-schedule-rule
            [buildingId]="building.id"
            [active]="schedule.active"
            [rule]="rule"
            (onRemoveRule)="removeRule($index)"
            (onChange)="validateRules()"></app-schedule-rule>
        </div>
      }
      <div class="bottom-border pb-4">
        <button mat-raised-button
                matTooltip="Add another rule"
                (click)="addRule()"
                data-cy="add-another-rule-button">
          <mat-icon class="text-xl-center" fontIcon="add_circle" />
          <span class="text-lg">{{ 'Add another rule' }}</span>
        </button>
      </div>
    </div>
  }
  @if (!validateDateAndTime && ((isNew && startControlDirty && endControlsDirty) || (!isNew && (startControlDirty || endControlsDirty)))){
      <mat-error data-cy="schedule-form-error">
        End date and time must be after start date and time!
      </mat-error>
    }
  <div class="flex flex-row w-full pt-4 space-x-4">
    <button
      mat-raised-button
      matTooltip="Save Schedule"
      color="primary"
      (click)="save()"
      [disabled]="scheduleForm.invalid || !validateRules || !validateDateAndTime || !validateStartSolarEventSelected || !validateEndSolarEventSelected"
      data-cy="save-schedule-button">
      <mat-icon class="text-xl-center" fontIcon="task_alt" />
      <span class="text-lg">{{saveLabel}}</span>
    </button>

    <button
      mat-raised-button
      matTooltip="Reset and Close"
      (click)="close()"
      data-cy="reset-and-close-schedule-button">
      <mat-icon class="text-xl-center">refresh</mat-icon>
      <span class="text-lg">Reset and close</span>
    </button>
    @if (!isNew) {
      <button
        class='delete'
        mat-raised-button
        matTooltip="Delete Schedule"
        (click)="delete()"
        data-cy="delete-schedule-button">
        <mat-icon class="text-xl-center">delete</mat-icon>
        <span class="text-lg">Delete</span>
      </button>
    }
  </div>
</form>
